// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  height: 55px;
}
.navbar .navbar-container {
  display: flex;
  align-items: center;
  height: 100%;
}
.navbar .navbar-container.initial {
  position: static;
}
.navbar .navbar-container.opened {
  position: absolute;
  left: 17px;
  transition: left 0.5s ease;
}
.navbar .sidebar.active {
  left: 0;
  transition: 0.4s;
}
.navbar .sidebar {
  position: fixed;
  background: #fff;
  top: 0;
  left: -100%;
  transition: 0.8s;
  z-index: 999;
  width: 230px;
  height: 100%;
  padding: 36px 20px;
}
.navbar .sidebar .user-info {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  column-gap: 16px;
  margin-top: -10px;
  margin-bottom: 30px;
  cursor: pointer;
}
.navbar .sidebar .user-info .info-img {
  width: 48px;
  height: 48px;
  border-radius: 100%;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
.navbar .sidebar .user-info .info-name {
  font-size: 19px;
  text-transform: uppercase;
  font-weight: 550;
  color: #334;
}
.navbar .sidebar .body-item {
  list-style: none;
  padding: 0;
  margin: 0;
}
.navbar .sidebar .body-item li {
  display: flex;
  padding: 10px;
  align-items: flex-end;
  margin: 10px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}
.navbar .sidebar .body-item li:hover {
  background-color: #f8f8f8;
  border-radius: 10px;
}
.navbar .sidebar .body-item li.active {
  background-color: #282881;
  border-radius: 10px;
  color: #fff;
}
.navbar .sidebar .body-item li.active .icon {
  color: #fff;
}
.navbar .sidebar .body-item li.active .title-menu {
  color: #fff;
}
.navbar .sidebar .body-item .link {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #334;
}
.navbar .sidebar .icon {
  font-size: 25px;
  margin-right: 10px;
}
.navbar .sidebar .title-menu {
  font-size: 17px;
  font-weight: 550;
}
.navbar .messages-list {
  position: fixed;
  top: 55px;
  right: 20px;
  z-index: 999;
}`, "",{"version":3,"sources":["webpack://./src/components/Navbar/navbar.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,YAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AACJ;AACI;EACE,gBAAA;AACN;AAEI;EACE,kBAAA;EACA,UAAA;EACA,0BAAA;AAAN;AAIE;EACE,OAAA;EACA,gBAAA;AAFJ;AAKE;EACE,eAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AAHJ;AAKI;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;AAHN;AAKM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,4CAAA;AAHR;AAMM;EACE,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;AAJR;AAQI;EACE,gBAAA;EACA,UAAA;EACA,SAAA;AANN;AASI;EACE,aAAA;EACA,aAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,sCAAA;AAPN;AASM;EACE,yBAAA;EACA,mBAAA;AAPR;AAWI;EACE,yBAAA;EACA,mBAAA;EACA,WAAA;AATN;AAWM;EACE,WAAA;AATR;AAYM;EACE,WAAA;AAVR;AAcI;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,WAAA;AAZN;AAeI;EACE,eAAA;EACA,kBAAA;AAbN;AAgBI;EACE,eAAA;EACA,gBAAA;AAdN;AAiBE;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AAfJ","sourcesContent":[".navbar {\n  background-color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;  \n  padding: 0 20px;  \n  height: 55px; \n\n  .navbar-container {\n    display: flex;\n    align-items: center;\n    height: 100%;  \n\n    &.initial {\n      position: static; \n    }\n  \n    &.opened {\n      position: absolute;\n      left: 17px;\n      transition: left 0.5s ease; \n    }\n  }\n    \n  .sidebar.active {\n    left: 0;\n    transition: 0.4s;\n  }\n\n  .sidebar {\n    position: fixed;\n    background: #fff;\n    top: 0;\n    left: -100%;\n    transition: .8s;\n    z-index: 999;\n    width: 230px;\n    height: 100%;\n    padding: 36px 20px;\n\n    .user-info {\n      display: flex;\n      justify-content: flex-start;\n      align-items: center;\n      column-gap: 16px;\n      margin-top: -10px;\n      margin-bottom: 30px;\n      cursor: pointer;\n\n      .info-img {\n        width: 48px;\n        height: 48px;\n        border-radius: 100%;\n        box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n\n      }\n      .info-name {\n        font-size: 19px;\n        text-transform: uppercase;\n        font-weight: 550;\n        color: #334;\n      }\n    }\n  \n    .body-item {\n      list-style: none;\n      padding: 0;\n      margin: 0;\n    }\n    \n    .body-item li {\n      display: flex;\n      padding: 10px;\n      align-items: flex-end;\n      margin: 10px;\n      cursor: pointer;\n      transition: background-color 0.3s ease;\n    \n      &:hover {\n        background-color: #f8f8f8;\n        border-radius: 10px;\n      }\n    }\n    \n    .body-item li.active {\n      background-color: #282881;\n      border-radius: 10px;\n      color: #fff;\n    \n      .icon {\n        color: #fff;\n      }\n    \n      .title-menu {\n        color: #fff;\n      }\n    }\n    \n    .body-item .link {\n      display: flex;\n      align-items: center;\n      text-decoration: none;\n      color: #334;\n    }\n    \n    .icon {\n      font-size: 25px;\n      margin-right: 10px;\n    }\n    \n    .title-menu {\n      font-size: 17px;\n      font-weight: 550;\n    }\n  }\n  .messages-list {\n    position: fixed;\n    top: 55px;\n    right: 20px;\n    z-index: 999;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
